import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { AdminGuidedTour } from '@/components/layout/AdminGuidedTour';
import { useTourStore } from '@/stores/tour';

export function AdminLayout() {
  const adminTourCompleted = useTourStore((s) => s.adminTourCompleted);
  const showAdminTour = useTourStore((s) => s.showAdminTour);
  const startAdminTour = useTourStore((s) => s.startAdminTour);

  useEffect(() => {
    if (!adminTourCompleted && !showAdminTour) {
      const t = setTimeout(() => startAdminTour(), 600);
      return () => clearTimeout(t);
    }
  }, [adminTourCompleted, showAdminTour, startAdminTour]);

  return (
    <AppShell crumbs={[{ label: 'Admin' }]}>
      <Outlet />
      <AdminGuidedTour />
    </AppShell>
  );
}
